import React, { useState, useMemo, useEffect } from 'react';
import { ThemeProvider } from '@mui/material';
import { themeCreator } from './base';
import { StylesProvider } from '@mui/styles';

export const ThemeContext = React.createContext(
  (themeName: string): void => { }
);

interface ThemeProviderWrapperProps {
  children: React.ReactNode;
  /** When set (e.g. by tenant config), this overrides localStorage for initial theme. */
  themeName?: string;
}

const ThemeProviderWrapper: React.FC<ThemeProviderWrapperProps> = (props) => {
  const { themeName: themeNameProp } = props;
  const curThemeName =
    themeNameProp ?? localStorage.getItem('appTheme') ?? 'PureLightTheme';
  const [themeName, _setThemeName] = useState(curThemeName);
  const theme = useMemo(() => themeCreator(themeName), [themeName]);
  useEffect(() => {
    if (themeNameProp != null && themeNameProp !== themeName) {
      _setThemeName(themeNameProp);
    }
  }, [themeNameProp]);
  const setThemeName = (name: string): void => {
    localStorage.setItem('appTheme', name);
    _setThemeName(name);
  };

  return (
    <StylesProvider injectFirst>
      <ThemeContext.Provider value={setThemeName}>
        <ThemeProvider theme={theme}>{props.children}</ThemeProvider>
      </ThemeContext.Provider>
    </StylesProvider>
  );
};

export default ThemeProviderWrapper;
